import React from "react";
import { Routes, Route } from "react-router-dom";
import { Container } from "react-bootstrap";

//Components
import NavbarCustom from "./components/Navbar";
import Footer from "./components/Footer";

//Pages
import Home from "./pages/Home";
import Syllabus from "./pages/Syllabus";
import Schedule from "./pages/Schedule";
import People from "./pages/People";
import Projects from "./pages/Projects";
import Tutorials from "./pages/Tutorials";
import Readings from "./pages/Readings";
import Assignments from "./pages/Assignments";

function App() {
  return (
    <div>
      <header>
        <NavbarCustom />
      </header>

      <Container>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/syllabus" element={<Syllabus />} />
          <Route path="/schedule" element={<Schedule />} />
          <Route path="/people" element={<People />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/tutorials" element={<Tutorials />} />
          <Route path="/readings" element={<Readings />} />
          <Route path="/assignments" element={<Assignments />} />
          <Route
            path="*"
            element={
              <center>
                <h1>404</h1>
              </center>
            }
          />
        </Routes>
      </Container>
      <footer>
        <Footer />
      </footer>
    </div>
  );
}

export default App;
